exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.error-dialog .notifit_error_message {\n    text-align: center;\n}\n.error-dialog .modal-dialog {\n    top: 25% !important;\n}\n.error-dialog .btn-success {\n    width: 90px;\n}\n.error-dialog .btn-primary {\n    width: 90px;\n}\n.general-nofi-modal-msg {\n    margin-top: 25px;\n    margin-bottom: -3px;\n}\n.notifit_error_message .site-menu-icon.modal-title-icon {\n    color: #F46800 !important;\n    font-size: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d055c966!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/v-components/error-dialog.vue
// module id = 1275
// module chunks = 12 14 18 19 21 35